// @flow
import React, { Children } from 'react';
import type { Node } from 'react';

import Loading from './Loading';

type Props = {
  showLoading: boolean,
  children: Array<Object> | Node,
};

const SmallLoadingWrapper = ({ showLoading, children }: Props) => {
  if (showLoading) return <Loading size="small" />;
  return Children.toArray(children);
};

export default SmallLoadingWrapper;



// WEBPACK FOOTER //
// ./src/components/Loading/SmallLoadingWrapper.jsx